export default __webpack_public_path__ + "static/media/Nik.df39d14b.png";